import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InspectionOrder } from '../classes/inspectionOrder';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class InspectionOrderService {
    API_INSPECTION_ORDER_URL = config.serverAddress + ':' + config.serverPort + '/inspection-order/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_INSPECTION_ORDER_URL + 'all');
    }
    getByID(id: string | null) {
        return this.http.get(this.API_INSPECTION_ORDER_URL + id);
    }
    getByIDInspection(idInspection: string | null) {
        return this.http.get(this.API_INSPECTION_ORDER_URL + 'inspection/' + idInspection);
    }
    create(inspectionOrder: InspectionOrder) {
        return this.http.post(this.API_INSPECTION_ORDER_URL + 'create', inspectionOrder);
    }
    update(inspectionOrder: InspectionOrder) {
        return this.http.put(this.API_INSPECTION_ORDER_URL + 'update', inspectionOrder);
    }
    resetByIDInspection(idInspection: number) {
        return this.http.put(this.API_INSPECTION_ORDER_URL + 'reset/inspection/' + idInspection, null);
    }
    delete(id: number) {
        return this.http.delete(this.API_INSPECTION_ORDER_URL + 'delete/' + id);
    }
}
